import { css } from "@emotion/react";
import { useEffect, useState } from "react";
import PhoneInput from "react-phone-input-2";

import "react-phone-input-2/lib/style.css";
import ValidationError from "@components/Form/ValidationError";
import { padding, fontStyle, border, colors, fontSize } from "@variables/index";

interface Props {
  country?: string;
  placeholder?: string;
  size?: size;
  value?: any;
  onChange?: any;
  error?: string;
  name?: string;
  disabled?: boolean;
  onBlur?: any;
}

type size = "small" | "normal" | "large";

const inputSizes: { [key in size]: string } = {
  small: fontSize[1],
  normal: fontSize[3],
  large: fontSize[5],
};

const PhoneNumberInput = ({
  placeholder = "Mobile num",
  size = "normal",
  value,
  onChange,
  error,
  name,
  onBlur,
  disabled = false,
}: Props) => {
  const [locData, setLocData] = useState<any>(null);

  const setInitialCountryCode = async () => {
    const res = await fetch("https://www.cloudflare.com/cdn-cgi/trace");
    const text = await res.text();
    const [, local] = RegExp("loc=(.*)", "g").exec(text) || [];
    if (!local) return;
    setLocData(local.trim().toLocaleLowerCase());
  };

  useEffect(() => {
    if (value) return;
    setInitialCountryCode();
  }, [value]);

  return (
    <div>
      <div
        css={phoneWrapperStyles({
          size: inputSizes[size || "normal"],
          hasErrors: !!error,
        })}
      >
        <PhoneInput
          css={phoneInputStyles({ disabled })}
          onBlur={onBlur}
          disabled={disabled}
          country={locData}
          placeholder={placeholder}
          value={value}
          onChange={(value: string) =>
            onChange({ target: { value: `+${value}`, name } })
          }
          inputProps={{ name }}
        />
      </div>
      {error && <ValidationError message={error} />}
    </div>
  );
};

export default PhoneNumberInput;

const phoneWrapperStyles = ({
  size,
  hasErrors,
}: {
  size: string;
  hasErrors: boolean;
}) => css`
  font-size: ${size};
  border: ${border.width[2]} solid ${colors.gray[300]};
  border-radius: ${border.radius[3]};
  display: flex;
  border-color: ${hasErrors && colors.red[500]};

  .flag-dropdown {
    border: none;
    border-right: ${border.width[2]} solid ${colors.gray[300]};
    border-top-left-radius: ${border.radius[3]};
    border-bottom-left-radius: ${border.radius[3]};
  }

  & ~ *:focus {
    outline: "none";
    border-color: ${colors.blue[500]};
  }

  &:focus-within {
    border-color: ${colors.blue[500]};
  }
`;

const phoneInputStyles = ({ disabled }: { disabled: boolean }) => css`
  display: flex;
  width: auto;
  padding: ${padding[7]};
  padding-left: 0;
  width: 100%;
  background: ${disabled && colors.gray[100]};

  font-size: inherit !important;

  .form-control {
    border: none;
    width: 100%;
    height: 100%;
    background: transparent;
    font-family: ${fontStyle.family["montserrat"]};
    color: ${colors.gray[800]};
    font-size: inherit !important;

    &:focus,
    &:hover {
      outline: "none";
    }
  }
`;
